import { render, staticRenderFns } from "./ViewOrganizationUserRents.vue?vue&type=template&id=536fc2ac"
import script from "./ViewOrganizationUserRents.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserRents.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationUserRents.vue?vue&type=style&index=0&id=536fc2ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports